<!-- =========================================================================================
    File Name: CarouselAutplay.vue
    Description: Carousel with Autplay
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card class="carousel-example" >
          <!-- swiper -->
          <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
            <swiper-slide>
              <img class="responsive" src="@/assets/images/pages/home/carousel/carousel1.jpg" alt="banner" style="height: 500px;">
            </swiper-slide>
            <swiper-slide>
              <b-img src="https://picsum.photos/300/150/?image=41" fluid alt="Fluid-grow image" height="5000"></b-img>
            </swiper-slide>
            <swiper-slide>
              <img class="responsive" src="@/assets/images/pages/home/carousel/26.jpg" alt="banner"  style="height: 500px;">
            </swiper-slide>
            <swiper-slide>
              <img class="responsive" src="@/assets/images/pages/home/carousel/27.jpg" alt="banner" style="height: 500px;">
            </swiper-slide>
           
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
          </swiper>
      </vx-card>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  data () {
    return {
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  }
}
</script>
